import React, { useState } from "react";
import PropTypes from "prop-types";
// ui

// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// components
import HeaderHome from "./HeaderHome";
import ErrorCapture from "./ErrorCapture";
import ConfirmModalHoc from "./ConfirmModalHoc";
// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

//
const TemplateHome = ({ children }) => {
  // style
  const classes = useStyles();
  // props

  // local state

  return (
    <>
      <ErrorCapture>
        <HeaderHome />
        <ConfirmModalHoc />
        {children}
      </ErrorCapture>
    </>
  );
};

TemplateHome.propTypes = {
  children: PropTypes.node,
};

TemplateHome.defaultProps = {
  children: null,
};

export default TemplateHome;
